import { AsYouType } from "libphonenumber-js/min";
import { object, string } from "yup";

export const nameValidation = (isNameUnavailable: boolean) =>
  object().shape({
    first_name: string().when({
      is: () => isNameUnavailable,
      then: string().required("First name is required"),
      otherwise: string().notRequired(),
    }),
    last_name: string().when({
      is: () => isNameUnavailable,
      then: string().required("Last name is required"),
      otherwise: string().notRequired(),
    }),
    phone: string()
      .required("Phone number is required")
      .test("is-valid-phone", "Invalid number", (value) => {
        if (!value) return false;
        try {
          const numberFormatter = new AsYouType();
          numberFormatter.input(value);
          const number = numberFormatter.getNumber();
          if (number?.nationalNumber) {
            return numberFormatter.isValid();
          }
          return false;
        } catch {
          return false;
        }
      }),
  });
